module.exports = __webpack_public_path__ + "static/media/arrow-up.81607370.svg";